import {
  Button,
  DatePickerFieldController,
  SelectFieldController,
  Stack,
} from '@fukuri-admins/ui/common';
import type { FormEventHandler } from 'react';
import styles from './styles.module.scss';

type Props = {
  /** 利用企業の選択肢 */
  clientOptions: { value: string; label: string }[];
  /** 契約プランの選択肢 */
  contractPlanOptions: { value: string; label: string }[];
  /** 開始日フィールドを無効化するか */
  isStartedOnDisabled: boolean;
  /** 契約プランセレクトを無効化するか */
  isContractPlanDisabled: boolean;
  /** 終了日の選択可能開始日 */
  endedOnFromDate: Date;
  /** 終了日の選択不可判定関数（true を返した日付が選択不可になる） */
  endedOnDisabledDate: (date: Date) => boolean;
  /** 保存ボタンを無効化するか */
  isButtonDisabled: boolean;
  /** フォーム送信ハンドラ */
  onSubmit: FormEventHandler<HTMLFormElement>;
  /** キャンセルボタンハンドラ */
  onCancel: React.ComponentProps<typeof Button>['onClick'];
};

/**
 * 企業契約期間 編集フォーム Presentation コンポーネント
 *
 * InternalAdmin の EditPartnerClientContract に準拠した表示構成。
 * - 利用企業（disabled Select）
 * - 契約プラン（Select / disabled 制御あり）
 * - 利用開始日（DatePicker / disabled 制御あり）
 * - 利用終了日（DatePicker）
 */
export const EditClientContractTermPresentation: React.FC<Props> = ({
  clientOptions,
  contractPlanOptions,
  isStartedOnDisabled,
  isContractPlanDisabled,
  endedOnFromDate,
  endedOnDisabledDate,
  isButtonDisabled,
  onSubmit,
  onCancel,
}) => (
  <form onSubmit={onSubmit}>
    <Stack direction='column' gap={24} width='466px'>
      <Stack direction='column' gap={16}>
        <SelectFieldController
          name='clientId'
          fieldWrapperProps={{
            labelText: '利用企業',
          }}
          select={{
            placeholder: '利用企業を選択してください',
            options: clientOptions,
            disabled: true,
          }}
        />
        <SelectFieldController
          name='contractPlanId'
          fieldWrapperProps={{ labelType: 'required', labelText: '契約プラン' }}
          select={{
            placeholder: '契約プランを選択してください',
            options: contractPlanOptions,
            disabled: isContractPlanDisabled,
          }}
        />
        <Stack direction='row' gap={16} alignItems='flex-start'>
          <div className={styles.dateFieldWrapper}>
            <DatePickerFieldController
              name='startedOn'
              fieldWrapperProps={{ labelType: 'required', labelText: '利用開始日' }}
              datePicker={{ disabled: isStartedOnDisabled }}
            />
          </div>
          <div className={styles.dateFieldWrapper}>
            <DatePickerFieldController
              name='endedOn'
              fieldWrapperProps={{ labelText: '利用終了日' }}
              datePicker={{ fromDate: endedOnFromDate, disabledDate: endedOnDisabledDate }}
            />
          </div>
        </Stack>
      </Stack>
      <Stack direction='row' gap={8}>
        <Button type='button' variant='outline' size='md' onClick={onCancel}>
          キャンセル
        </Button>
        <Button type='submit' size='md' disabled={isButtonDisabled}>
          保存
        </Button>
      </Stack>
    </Stack>
  </form>
);
